import { SharedStyles } from '@opencare/shared-styles';
import { IconCheck, IconGiftFilled } from '@tabler/icons-react';
import styled, { css } from 'styled-components';

import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { applyStylesForScreenSize, SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';

import { Checkbox as FormCheckbox } from 'pages/checkout/components/common/checkbox-styled-component';
import { FormError } from 'pages/checkout/components/common/input-styled-components';
import { svgComponentToMarkupString } from 'utils/styledComponentSvg';

import { CheckboxLabeledInput } from '../../Confirm-styled-components';

const IconCheckDataUri = svgComponentToMarkupString(
  IconCheck,
  { color: SharedStyles.COLOR.SURFACE.PRIMARY.DEFAULT, size: 16 },
);
const IconCheckDataUriMobile = svgComponentToMarkupString(
  IconCheck,
  { color: SharedStyles.COLOR.SURFACE.PRIMARY.DEFAULT, size: 20 },
);

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 14px;
  overflow: hidden;
  background: linear-gradient(
    127deg,
    ${SharedStyles.COLOR.SURFACE.PRIMARY.HOVER} 1.16%,
    ${SharedStyles.COLOR.SURFACE.SECONDARY.DARK} 98.7%
  );
  color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE};
`;

export const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 16px;
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const GiftIcon = styled(IconGiftFilled).attrs({
  size: 24,
})`
  flex-shrink: 0;
  color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE};
`;

export const Title = styled.h3`
  ${TYPOGRAPHY.OPEN_SANS.bold}
  font-size: 18px;
  line-height: 24px;
  color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE};
  margin: 0;
`;

export const CheckboxesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledCheckboxLabeledInput = styled(CheckboxLabeledInput)`
  color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE};
  cursor: pointer;
  
  span {
    ${TYPOGRAPHY.OPEN_SANS.base}
    color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE} !important;
    font-size: 14px !important;
    line-height: 21px !important;
  }
  
  strong {
    color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE} !important;
  }
`;

export const StyledFormCheckbox = styled(FormCheckbox)`
  position: relative;
  top: 2px;
  border-color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE};
  background: none;
  cursor: pointer;
  
  &:checked {
    background-color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE};
    border-color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE};
    
    &::before {
      content: url(${IconCheckDataUri});
      display: block;
      width: 16px;
      height: 16px;
    }
  }
  
  ${applyStylesForScreenSize(
    [SCREEN_SIZES.PHONE],
    css`
      &:checked::before {
        content: url(${IconCheckDataUriMobile});
        width: 20px;
        height: 20px;
      }
    `,
  )}
`;

export const InstructionsSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 8px;
  background: rgba(36, 37, 40, 0.2);
`;

export const InstructionsHeading = styled.h4`
  ${TYPOGRAPHY.OPEN_SANS.bold}
  font-size: 16px;
  line-height: 22px;
  color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE};
  margin: 0;
`;

export const InstructionsText = styled.p`
  ${TYPOGRAPHY.OPEN_SANS.base}
  font-size: 12px;
  line-height: 20px;
  color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE};
  margin: 0;
`;

export const EligibilityLink = styled.a`
  ${TYPOGRAPHY.OPEN_SANS.semiBold}
  font-size: 14px;
  line-height: 20px;
  color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE};
  text-decoration: underline;
  cursor: pointer;
  
  &:hover {
    opacity: 0.8;
  }
`;

export const StyledFormError = styled(FormError)`
  color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE};
  opacity: 0.9;
`;

export const LabelText = styled.span`
  ${TYPOGRAPHY.OPEN_SANS.base}
  color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE} !important;
  
  strong {
    color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE} !important;
  }
`;

